import {
  Send, Loader2, Image 
} from 'lucide-react';
import { Button } from '@/components/ui/button';

interface InputAreaProps {
  readonly message: string;
  readonly inputRef: React.RefObject<HTMLInputElement | null>;
  readonly fileInputRef: React.RefObject<HTMLInputElement | null>;
  readonly isPending: boolean;
  readonly canSend: boolean;
  readonly canTakeAction: boolean;
  readonly showActions: boolean;
  readonly onMessageChange: (value: string) => void;
  readonly onKeyDown: (e: React.KeyboardEvent) => void;
  readonly onSend: () => void;
  readonly onImageSelect: (e: React.ChangeEvent<HTMLInputElement>) => void;
  readonly onShowActions: () => void;
}

export function InputArea({
  message,
  inputRef,
  fileInputRef,
  isPending,
  canSend,
  canTakeAction,
  showActions,
  onMessageChange,
  onKeyDown,
  onSend,
  onImageSelect,
  onShowActions,
}: InputAreaProps) {
  return (
    <div className="border-t border-slate-100 p-3 bg-slate-50/50 flex-shrink-0">
      <div className="flex gap-2">
        <input
          type="file"
          ref={fileInputRef}
          onChange={onImageSelect}
          accept="image/*"
          multiple
          className="hidden"
        />
        <Button
          variant="outline"
          size="icon"
          onClick={() => fileInputRef.current?.click()}
          className="border-slate-200 text-slate-500 hover:text-slate-700"
          title="Attach images"
        >
          <Image className="h-4 w-4" />
        </Button>
        <input
          ref={inputRef}
          type="text"
          value={message}
          onChange={(e) => onMessageChange(e.target.value)}
          onKeyDown={onKeyDown}
          placeholder="Type a message..."
          className="flex-1 rounded-md border border-slate-200 bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-900 placeholder:text-slate-400"
          disabled={isPending}
        />
        <Button
          variant="outline"
          onClick={onSend}
          disabled={!canSend || isPending}
          className="border-slate-200"
        >
          {isPending ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />}
        </Button>
        {canTakeAction && !showActions && (
          <Button onClick={onShowActions} className="bg-slate-900 hover:bg-slate-800">
            Take Action
          </Button>
        )}
      </div>
    </div>
  );
}
